export default __webpack_public_path__ + "static/media/logo3.b1c9b5e3.png";